export default "__VITE_ASSET__fCGaTbee__"